module.exports = __webpack_public_path__ + "img/star.2f96c248.gif";